/**
 * Shared COD shipping helpers for Bambé Classy theme.
 * Config comes from window.BAMBE_SHIPPING (set in scripts-tag.liquid).
 */
(function (window) {
  'use strict';

  function cfg() {
    return window.BAMBE_SHIPPING || {};
  }

  function fee() {
    var n = Number(cfg().fee);
    if (!isFinite(n) || n < 0) n = Number(window.BAMBE_COD_DELIVERY_FEE);
    return isFinite(n) && n >= 0 ? n : 35;
  }

  function freeFrom() {
    var n = Number(cfg().freeFrom);
    if (!isFinite(n) || n < 0) n = Number(window.BAMBE_COD_FREE_FROM);
    return isFinite(n) && n >= 0 ? n : 400;
  }

  function freeTag() {
    return cfg().freeTag || 'FreeDelivery';
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags;
    if (typeof tags === 'string') {
      return tags.split(',').map(function (t) {
        return t.trim();
      });
    }
    return [];
  }

  function itemHasFreeTag(item) {
    if (!item) return false;
    var tags = item.product_tags || item.tags || (item.product && item.product.tags) || [];
    return normalizeTags(tags).indexOf(freeTag()) !== -1;
  }

  function cartHasFreeTag(cartOrItems) {
    var items = Array.isArray(cartOrItems)
      ? cartOrItems
      : (cartOrItems && cartOrItems.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (itemHasFreeTag(items[i])) return true;
    }
    return false;
  }

  /** /cart.js often omits product tags — fall back to Liquid-rendered DOM markers. */
  function domHasFreeTag() {
    if (document.querySelector('[data-has-free-tag="true"]')) return true;
    if (document.querySelector('[data-bambe-free-delivery="1"]')) return true;
    return false;
  }

  function resolveHasFreeTag(cartOrItems, explicit) {
    if (typeof explicit === 'boolean') return explicit;
    if (cartHasFreeTag(cartOrItems)) return true;
    return domHasFreeTag();
  }

  /**
   * @param {number} subtotalMad - cart/discounted subtotal in store currency units
   * @param {boolean} hasFreeDeliveryTag
   * @returns {{ shipping: number, total: number, fee: number, freeFrom: number }}
   */
  function compute(subtotalMad, hasFreeDeliveryTag) {
    var f = fee();
    var min = freeFrom();
    var price = Number(subtotalMad) || 0;
    var shipping = price >= min || hasFreeDeliveryTag ? 0 : f;
    return {
      shipping: shipping,
      total: price + shipping,
      fee: f,
      freeFrom: min,
    };
  }

  function formatMoneyMad(cents) {
    var amount = Math.round((Number(cents) || 0) / 100);
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.cartStrings && window.cartStrings.money_format) {
      try {
        return Shopify.formatMoney(cents, window.cartStrings.money_format);
      } catch (e) {}
    }
    return amount + ((document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('fr') === 0 ? ' dh' : ' درهم');
  }

  /**
   * Update free-shipping progress bars after cart qty changes (checkout + drawer).
   * @param {number|object} totalOrCart - subtotal in MAD, or cart JSON with total_price (cents)
   * @param {boolean} [hasFreeDeliveryTag]
   */
  function refreshFreeshipBars(totalOrCart, hasFreeDeliveryTag) {
    var totalMad = 0;
    var cartObj = totalOrCart && typeof totalOrCart === 'object' ? totalOrCart : null;
    var tagged = resolveHasFreeTag(cartObj, hasFreeDeliveryTag);
    if (cartObj) {
      if (cartObj.total_price != null) totalMad = Math.round(Number(cartObj.total_price) / 100);
      else if (cartObj.items_subtotal_price != null) {
        totalMad = Math.round(Number(cartObj.items_subtotal_price) / 100);
      }
    } else {
      totalMad = Number(totalOrCart) || 0;
    }

    var threshold = freeFrom();
    var bars = document.querySelectorAll('[data-bambe-freeship], .bambe-freeship-bar, .cart-drawer__freeship-top, .tca-footer__freeship');
    if (!bars.length) return;

    bars.forEach(function (root) {
      var data = root.querySelector('.process-bar__data');
      var thr = Number(root.getAttribute('data-threshold') || (data && data.getAttribute('data-ammount')) || threshold) || threshold;
      var notReachedTpl =
        root.getAttribute('data-not-reached') ||
        (data && data.getAttribute('data-not-reached')) ||
        '';
      var successTpl =
        root.getAttribute('data-success') || (data && data.getAttribute('data-success')) || '';
      var isFree = tagged || totalMad >= thr;
      var remaining = Math.max(0, Math.round(thr - totalMad));
      var pct = thr > 0 ? Math.min(100, Math.round((totalMad / thr) * 100)) : 100;
      if (isFree) pct = 100;

      var textEl = root.querySelector('.freeship__text');
      var truck = root.querySelector('.freeship__truck, .text > svg');
      var row = root.querySelector('.text');
      var barItem = root.querySelector('.process-bar__item');
      var percent = root.querySelector('.process-bar__percent');

      if (textEl) {
        if (isFree) {
          textEl.textContent = successTpl || textEl.textContent;
          textEl.classList.add('is-success');
        } else {
          textEl.classList.remove('is-success');
          var amountEl = textEl.querySelector('.freeship__amount');
          var locale = root.getAttribute('data-locale') || 'ar';
          var amountLabel =
            locale === 'fr' ? String(remaining) + ' dh' : String(remaining) + ' درهم';
          if (amountEl) {
            // Prefer updating only the amount node — avoids layout thrash from full innerHTML
            amountEl.textContent = amountLabel;
          } else {
            var msg = (notReachedTpl || '').replace(/\[amount\]/g, String(remaining));
            msg = msg.replace(
              /(\d+)\s*(dh|DH|درهم)/i,
              '<strong class="freeship__amount">$1 $2</strong>'
            );
            if (!msg) {
              msg =
                locale === 'fr'
                  ? 'Achetez encore <strong class="freeship__amount">' +
                    amountLabel +
                    '</strong> et bénéficiez de la livraison gratuite !'
                  : 'قم بشراء <strong class="freeship__amount">' +
                    amountLabel +
                    '</strong> إضافية و احصل على توصيل مجاني الآن!';
            }
            textEl.innerHTML = msg;
          }
        }
      }
      if (truck) {
        if (isFree) truck.classList.add('is-hidden');
        else truck.classList.remove('is-hidden');
      }
      if (row) {
        if (isFree) row.classList.add('is-free');
        else row.classList.remove('is-free');
      }
      if (barItem) {
        if (isFree) barItem.classList.add('is-active');
        else barItem.classList.remove('is-active');
      }
      if (percent) percent.style.width = pct + '%';
      if (data) data.setAttribute('data-compare', isFree ? 'true' : 'false');
      if (isFree && tagged) root.setAttribute('data-has-free-tag', 'true');
      else if (!tagged) root.setAttribute('data-has-free-tag', 'false');
    });
  }

  /**
   * Update cart drawer shipping row + grand total from cart JSON.
   * FreeDelivery tags are often missing from /cart.js — pass hasFreeDeliveryTag when known,
   * or rely on Liquid DOM markers (data-has-free-tag / data-bambe-free-delivery).
   */
  function refreshDrawerTotals(cart, hasFreeDeliveryTag) {
    if (!cart) return null;
    var tagged = resolveHasFreeTag(cart, hasFreeDeliveryTag);
    refreshFreeshipBars(cart, tagged);
    var subEl = document.getElementById('CartDrawer-Subtotal');
    var shipEl = document.getElementById('CartDrawer-Shipping');
    var grandEl = document.getElementById('CartDrawer-GrandTotal');
    var summary = document.querySelector('.cart-drawer__summary');
    if (!subEl || !shipEl || !grandEl) return null;

    var shipRow = shipEl.closest('.cart-drawer__shipping');

    if (!cart.item_count) {
      subEl.textContent = formatMoneyMad(0);
      shipEl.textContent = formatMoneyMad(0);
      shipEl.setAttribute('data-bambe-shipping-cents', '0');
      grandEl.textContent = formatMoneyMad(0);
      grandEl.setAttribute('data-bambe-grand-cents', '0');
      if (shipRow) {
        shipRow.classList.remove('is-free', 'is-paid');
      }
      if (summary) summary.setAttribute('hidden', '');
      return { shipping: 0, total: 0, fee: fee(), freeFrom: freeFrom() };
    }

    if (summary) summary.removeAttribute('hidden');

    var subtotalMad = Math.round((cart.total_price || 0) / 100);
    var result = compute(subtotalMad, tagged);
    var shippingCents = Math.round(result.shipping * 100);
    var grandCents = (cart.total_price || 0) + shippingCents;

    subEl.textContent = formatMoneyMad(cart.total_price);
    var freeLabel =
      (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('fr') === 0
        ? 'Gratuit'
        : 'مجاني';
    shipEl.textContent = result.shipping === 0 ? freeLabel : formatMoneyMad(shippingCents);
    shipEl.setAttribute('data-bambe-shipping-cents', String(shippingCents));
    if (shipRow) {
      shipRow.classList.toggle('is-free', result.shipping === 0);
      shipRow.classList.toggle('is-paid', result.shipping > 0);
    }
    grandEl.textContent = formatMoneyMad(grandCents);
    grandEl.setAttribute('data-bambe-grand-cents', String(grandCents));
    return result;
  }

  /**
   * Resolve FreeDelivery when /cart.js has no tags: check DOM, else fetch product.js handles.
   */
  function resolveHasFreeTagAsync(cart) {
    if (resolveHasFreeTag(cart)) return Promise.resolve(true);
    var items = (cart && cart.items) || [];
    if (!items.length) return Promise.resolve(false);
    var tag = freeTag();
    return Promise.all(
      items.map(function (item) {
        var handle = item.handle;
        if (!handle) return Promise.resolve(false);
        return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .then(function (p) {
            return normalizeTags(p.tags).indexOf(tag) !== -1;
          })
          .catch(function () {
            return false;
          });
      })
    ).then(function (flags) {
      for (var i = 0; i < flags.length; i++) {
        if (flags[i]) return true;
      }
      return false;
    });
  }

  function repairDrawerTotalsIfEmpty() {
    var shipEl = document.getElementById('CartDrawer-Shipping');
    if (!shipEl) return;
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.item_count) {
          refreshDrawerTotals(cart, false);
          return;
        }
        var needsRepair = !shipEl.textContent.trim();
        var shipRow = shipEl.closest('.cart-drawer__shipping');
        var shipIsFree = !!(shipRow && shipRow.classList.contains('is-free'));
        var barSaysBuyMore = !!document.querySelector(
          '.cart-drawer__freeship-top .freeship__text:not(.is-success), [data-bambe-freeship] .freeship__text:not(.is-success)'
        );
        /* Only resolve tags when shipping is free but the progress bar still upsells */
        if (!needsRepair && !(shipIsFree && barSaysBuyMore)) return;
        return resolveHasFreeTagAsync(cart).then(function (tagged) {
          refreshDrawerTotals(cart, tagged);
        });
      })
      .catch(function () {});
  }

  window.BambeShipping = {
    fee: fee,
    freeFrom: freeFrom,
    freeTag: freeTag,
    itemHasFreeTag: itemHasFreeTag,
    cartHasFreeTag: cartHasFreeTag,
    domHasFreeTag: domHasFreeTag,
    resolveHasFreeTag: resolveHasFreeTag,
    compute: compute,
    formatMoneyMad: formatMoneyMad,
    refreshFreeshipBars: refreshFreeshipBars,
    refreshDrawerTotals: refreshDrawerTotals,
    repairDrawerTotalsIfEmpty: repairDrawerTotalsIfEmpty,
  };

  // Keep legacy globals in sync for older checkout/thank-you code paths.
  window.BAMBE_COD_DELIVERY_FEE = fee();
  window.BAMBE_COD_FREE_FROM = freeFrom();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairDrawerTotalsIfEmpty);
  } else {
    repairDrawerTotalsIfEmpty();
  }
})(window);
